function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD24D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EDB937"
    },
    cx: 256,
    cy: 421.646,
    rx: 182.284,
    ry: 14.37
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.224h380.036c12.484,0,22.702,10.218,22.702,22.702v234.109H43.28V89.925 C43.28,77.442,53.494,67.224,65.982,67.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M58.693,308.617h394.609V89.925c0-3.976-3.309-7.289-7.285-7.289H65.982 c-3.976,0-7.285,3.309-7.285,7.289v218.692H58.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.72,324.03v24.826c0,12.489-11.261,22.702-25.024,22.702H68.31 c-13.763,0-25.024-10.213-25.024-22.702V324.03h425.439H468.72z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 256,
    cy: 346.803,
    r: 7.816
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.067,407.273l36.095,11.564H170.837l29.124-11.564v-35.711h105.107v35.711H305.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.961,407.273h105.107l36.096,11.564v4.981H256h-85.163v-4.981L199.961,407.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191"
    },
    d: "M199.961,371.561h105.107v36.323L199.961,371.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.562,108.343h212.876h31.688c3.839,0,6.981,3.142,6.981,6.981v41.546v151.743H110.888l0,0 V156.871v-41.546c0-3.839,3.142-6.981,6.981-6.981h31.688H149.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M117.874,108.343H394.13c3.839,0,6.981,3.142,6.981,6.981v13.963H110.893v-13.963 C110.893,111.485,114.035,108.343,117.874,108.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.094,115.575h140.192c1.033,0,1.876,0.843,1.876,1.876v3.479c0,1.033-0.843,1.876-1.876,1.876 H240.094c-1.033,0-1.876-0.843-1.876-1.876v-3.479C238.218,116.42,239.061,115.575,240.094,115.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M124.817,114.329c2.218,0,4.019,1.796,4.019,4.019s-1.801,4.019-4.019,4.019 c-2.223,0-4.024-1.8-4.024-4.019C120.794,116.125,122.595,114.329,124.817,114.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M140.685,114.329c2.223,0,4.019,1.796,4.019,4.019s-1.796,4.019-4.019,4.019 c-2.218,0-4.019-1.8-4.019-4.019C136.666,116.125,138.467,114.329,140.685,114.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M156.557,114.329c2.218,0,4.019,1.796,4.019,4.019s-1.8,4.019-4.019,4.019 c-2.223,0-4.024-1.8-4.024-4.019C152.534,116.125,154.335,114.329,156.557,114.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 256,
    cy: 192.205,
    r: 48.954
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 231.558,
    cy: 245.63,
    r: 48.954
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECF0F1"
    },
    cx: 280.442,
    cy: 245.63,
    r: 48.954
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M279.408,235.218c-2.962-13.678-11.64-25.228-23.408-32.024 c-11.768,6.792-20.451,18.341-23.412,32.024c6.952,3.792,14.929,5.948,23.412,5.948 C264.478,241.166,272.455,239.009,279.408,235.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M256,203.193c11.768,6.792,20.446,18.341,23.408,32.024c12.294-6.706,21.394-18.527,24.441-32.602 c-6.952-3.792-14.934-5.948-23.412-5.948c-8.901,0-17.246,2.374-24.441,6.526H256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M232.588,235.218c2.962-13.678,11.64-25.228,23.412-32.024c-7.194-4.152-15.541-6.526-24.441-6.526 c-8.478,0-16.455,2.157-23.412,5.948c3.047,14.077,12.147,25.896,24.441,32.597V235.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M256,241.166c-8.478,0-16.455-2.157-23.412-5.948c-0.726,3.355-1.109,6.839-1.109,10.413 c0,18.138,9.863,33.973,24.522,42.432c14.654-8.46,24.517-24.295,24.517-42.432c0-3.574-0.384-7.057-1.109-10.408 c-6.957,3.792-14.929,5.948-23.408,5.948v-0.005H256z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.a9bf36cfa702be91229f3c6e2364c1da.svg";
export { ForwardRef as ReactComponent };